import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { OrderClientInterface, TransferInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransferProvider } from '../providers/transfer-provider.service';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SignTransferUseCaseParams {
    signatories: OrderClientInterface[];
    transfer: TransferInterface;
}

@Injectable()
export class SignTransferUseCase implements UseCaseWithParam<SignTransferUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private contractProvider: ContractProvider, private transferProvider: TransferProvider) {}

    bind(params: SignTransferUseCaseParams): Observable<Transaction<boolean>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.transferProvider.signTransfer(contract.encryptedCode, params.signatories, params.transfer),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
